import { TApiActionValidatorResponse } from "@propely/propely-typings";
import { propelyApi } from "@src/libs/firebase/api";
import { useQuery } from "react-query";

export const apiActionValidatorQueryKey = () => ["get-api-ActionValidator"];

export const fetchAPIActionValidator = async () => {
  const response = await propelyApi().get("/actionValidator");
  return TApiActionValidatorResponse.parse(response.data);
};

export const useAPIActionValidator = () => {
  const $actionValidator = useQuery(apiActionValidatorQueryKey(), () => fetchAPIActionValidator());
  const actionValidator = $actionValidator.data;
  return { $actionValidator, actionValidator };
};

